import React, { useEffect, useState, useRef } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import AnimatedRoutes from './components/AnimatedRoutes';
import Footer from './components/Footer';
import './App.css'; // Import your app-wide styles
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import background1 from './images/glass.jpg';
import { motion } from 'framer-motion';
import { ScrollProvider } from './components/ScrollContext';

function App() {
  
  return (
    <div>
      <Router>
        <AppContent />
      </Router>
    </div>
  );
}

function AppContent() {
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState('/');
    const handleTabChange = (newTab) => {
        setCurrentTab(newTab);
    };
  const [backgroundColor, setBackgroundColor] = useState('white');
  const [textColor, setTextColor] = useState('white');
  const [activeSection, setActiveSection] = useState('home');
  
  // Create refs for each section
  const homeRef = useRef(null);
  const whoAreWeRef = useRef(null);
  const whyUsRef = useRef(null);
  const galleryRef = useRef(null);
  const contactRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.6, // Section is considered in view when 60% is visible
    };

    const callback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Update active section based on the element's id
          setActiveSection(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);
    const sections = [homeRef, whoAreWeRef, whyUsRef, galleryRef, contactRef];
    sections.forEach(ref => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      sections.forEach(ref => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });
    };
  }, []);


  useEffect(() => {
    // Handle styles or side effects based on the current location
    // console.log('Location changed:', location.pathname);
    // Example: Change background color based on the route
    if (location.pathname === '/gallery') {
      setBackgroundColor('black'); // Default background color
      setTextColor('white ');
    }
    else if (location.pathname === '/contact') {
      setBackgroundColor('black');
      setTextColor('white');
    } 
    else {

      setBackgroundColor('black'); // Default background color
      setTextColor('white ');
      
    }

    // You can add more conditions for other routes as needed
  }, [location]);

  return (
    <ScrollProvider>
    <div className="App" style={{ backgroundColor, color: textColor, transition: 'background-color 1s ease' }}>
      <Navbar onTabChange={handleTabChange} />
      <AnimatedRoutes />
      <Footer />
    </div>
    </ScrollProvider>
  );
}

export default App;
